import { useQuery } from '@tanstack/react-query';

import { post } from 'src/utils/helpers/http';
import { useBaseAPIParams } from 'src/utils/hooks/useBaseAPIParams';

export const CreateMobileCheckoutCartUrlKey = 'create-mobile-checkout-cart-url';

type CreateMobileCheckoutCartUrlResponse = {
  instore_cart_url: string;
};

export function useCreateMobileCheckoutCartUrlQuery(shipmentId: number, sessionKey = 0) {
  const baseAPIParams = useBaseAPIParams();

  return useQuery({
    queryKey: [CreateMobileCheckoutCartUrlKey, shipmentId, sessionKey],
    queryFn: async () => {
      return post<CreateMobileCheckoutCartUrlResponse>('/dutchiepay/create-mobile-checkout-cart-url', {
        ...baseAPIParams,
        ShipmentId: shipmentId,
      });
    },
    enabled: shipmentId > 0,
    staleTime: Infinity,
    retry: false,
  });
}
